export class NameFromShortcodeValueConverter {
    toView(value: string) {
        switch (value) {
            case 'DS':
                return 'Divica Sales';
            case 'CG':
                return 'Chicks Gold';
            case 'GT':
                return 'Gamer Total';
            case 'CX':
                return 'Chicks X';
            default:
                return 'UNDEFINED SHORTCODE';
        }
    }
}
